import { customerWebsiteBaseUrl } from '../config';

function callbackUrl() {
  return window.location.href;
}

export function contactUsLink() {
  return `${customerWebsiteBaseUrl}/contact-us`;
}

export function logoutLink() {
  return `${customerWebsiteBaseUrl}/profile/logout?callback=${callbackUrl()}`;
}

export function loginLink() {
  return `${customerWebsiteBaseUrl}/profile/login?callback=${callbackUrl()}`;
}

export function signupLink() {
  return `${customerWebsiteBaseUrl}/profile/signup?callback=${callbackUrl()}`;
}

export function selfToursLink() {
  return `${customerWebsiteBaseUrl}/profile/dashboard`;
}

// TODO: need to get the cognito link for edit profile
export function updateProfileLink() {
  return `${customerWebsiteBaseUrl}/profile/dashboard`;
}
